import classNames from 'classnames';
import {
  SUBTITLE_BACKGROUND_OPTIONS,
  SUBTITLE_COLOR_OPTIONS,
  SUBTITLE_SIZE_OPTIONS,
  SUBTITLE_STROKE_OPTIONS,
} from 'src/interfaces/enums';
import { ISubtitleStyle } from 'src/interfaces/Subtitle';
import styles from './styles.module.scss';

export interface ISubtitleTextProps extends ISubtitleStyle {
  currentText: string;
  className?: string;
}

const SubtitleText = ({
  currentText,
  className,
  size = SUBTITLE_SIZE_OPTIONS.medium,
  color = SUBTITLE_COLOR_OPTIONS.yellow,
  background = SUBTITLE_BACKGROUND_OPTIONS.black,
  stroke = SUBTITLE_STROKE_OPTIONS.regular,
}: ISubtitleTextProps) => (
  <div
    role='caption'
    data-testid='subtitle-text'
    className={classNames(
      styles.subtitleText,
      styles[`stroke-${stroke}`],
      styles[`bg-${background}`],
      styles[`size-${size}`],
      styles[`color-${color}`],
      className,
    )}
  >
    {currentText || ''}
  </div>
);

export default SubtitleText;
